import "./sidebar.css";
import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useRoleContext } from "src/hooks/use-alert";
import permissionsJson from "src/permissions.json";

const SideBar = (props) => {
  const { roles } = useRoleContext();

  const navigate = useNavigate();

  const handleNavigation = (path, policyName, roleNames) => {
    const permissions = permissionsJson;
    //check if the logged user role is authorized ans contained in the permitted roles for this action (property policyName)
    var policyRoles = permissions.Policy.authorizations.find(
      (auth) => auth.name === policyName
    ).roles;
    let unauthorized = true;
    if (roleNames.length === 0) {
      let rolesString = localStorage.getItem("roles");
      roleNames = rolesString === null ? [] : JSON.parse(rolesString);
    }
    roleNames.forEach((r) => {
      let check = policyRoles.includes(r);
      unauthorized = check ? false : true;
    });

    if (path === "/dashboard/account-management" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "/dashboard/explore-complexes" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "/dashboard/reports-history" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "/dashboard/alerts-and-notifications" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "/dashboard/data-explorer" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "/dashboard/monitoring" && unauthorized) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } 
    else {
      navigate(path);
    }
  };
  return (
    <div>
      <div
        className={`sidebar-body ${props.sideBarClass}`}
        style={{
          backgroundColor: props.sideBarBackGroud,
          width: props.sidebarWidth,
        }}
      >
        <div>
          {props.elements.map((v, k) => {
            if (k === 0) {
              return <div key={k}>{v} </div>;
            } else {
              return (
                <div
                  key={k}
                  onClick={() => handleNavigation(v[0], v[2], roles)}
                >
                  <img
                    src={v[1]}
                    className={props.imgSidebarClass}
                    alt={"dc"}
                  ></img>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

SideBar.defaultProps = {
  sideBarBackGroud: "#282b30",
  imgSidebarClass: "imgSidebar",
  sidebarWidth: "90%",
};

SideBar.propTypes = {
  sideBarClass: PropTypes.string,
  sideBarBackGroud: PropTypes.string,
  elements: PropTypes.array.isRequired,
  imgSidebarClass: PropTypes.string,
  sidebarWidth: PropTypes.string,
};

export default SideBar;
